import gql from "graphql-tag";

export const ADD_FIREBASE_TOKEN = gql`
mutation ADD_FIREBASE_TOKEN($token_id: String) {
    insert_fcm_token_user_one(object: {token_id: $token_id}, on_conflict: {constraint: token_user_pkey}) {
      token_id
      user_id
    }
  }
`